<template>
    <drawer title="Media">
        <template v-slot:header-primary>
            <!-- <drawer-search /> -->
        </template>

        <navigation-tree item-type="media" />
    </drawer>
</template>

<script>
import NavigationTree from '@/components/page-editor/navigation-tree/navigation-tree';
import Drawer from '@/components/shared/drawer/drawer';

export default {
    components: { NavigationTree, Drawer },
};
</script>
